const $ = window.$;

$(document).ready(function() {
  $('.userimg').each(function() {
    const $img = $(this);
    if ($img.is('[style*=\'width\']') && $img.is('[style*=\'height\']')) return;
    $img.css({'object-fit': 'contain'});
    const targetHeight = Math.floor(this.width * this.naturalHeight / this.naturalWidth);
    const verticalMargin = targetHeight - this.height;
    // 縦マージンが1%以上ずれている場合
    // object-fitによる縦幅計算時に切り捨てられることで発生している誤差を除外する
    if (verticalMargin < 0 - (this.height * 0.01)) {
      const marginHalf = Math.abs(verticalMargin / 2);
      $img.css({
        'margin-top': `-${marginHalf}px`,
        'margin-bottom': `-${marginHalf}px`
      });
    }
  });
});
